import { Link } from 'react-router-dom';

export default function SiteIntro() {
  return (
    <section className="w-full bg-primary-900">
      <div className="container-page py-14 md:py-16">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.2fr_1fr]">
          <div>
            <span className="text-xs font-medium uppercase tracking-[0.28em] text-accent-400">
              About This Site
            </span>
            <h2 className="mt-3 font-heading text-2xl font-semibold text-background-50 md:text-3xl">
              一个专注吉泽明步影视资料的档案站
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
              本站围绕影视演员吉泽明步的资料与作品展开，系统整理其电影、电视剧与短片作品，并提供明星档案、作品介绍与影视动态。
              我们希望以清晰的信息层级与克制的视觉语言，为影迷与影视爱好者提供一个便于查询与阅读的资料入口。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/profile"
                className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-primary-950 whitespace-nowrap transition-colors hover:bg-accent-400 cursor-pointer"
              >
                查看明星资料
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 rounded-md border border-background-200/50 px-5 py-2.5 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10 cursor-pointer"
              >
                了解本站
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: 'ri-film-line', label: '作品收录', value: '18 部' },
              { icon: 'ri-calendar-line', label: '活跃年份', value: '2015 起' },
              { icon: 'ri-price-tag-3-line', label: '作品类型', value: '3 类' },
              { icon: 'ri-newspaper-line', label: '动态条目', value: '10 条' },
            ].map((item) => (
              <div key={item.label} className="rounded-lg border border-primary-700/60 bg-primary-800/50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-700 text-accent-300">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <p className="mt-4 font-heading text-xl font-semibold text-background-50">{item.value}</p>
                <p className="mt-1 text-xs text-background-300">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}